// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sec-ind-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  min-width: 328px;
}

.sec-ind-container .sec-ind-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.sec-ind-container .sec-ind-table thead th {
  height: 32px;
  border-bottom: 1px solid var(--border-line);
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
  text-align: right;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: top;
  white-space: nowrap;
}
.sec-ind-container .sec-ind-table thead th:first-child {
  border: none;
}

.sec-ind-container .sec-ind-table thead th.no {
  text-align: center;
  width: 8px;
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table thead th.ctry {
  width: 28px;
  min-width: 28px;
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table thead th.ticker {
  text-align: left;
  width: 62px;
  min-width: 62px;
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table thead th.name {
  text-align: left;
  min-width: 150px;
}

.sec-ind-container .sec-ind-table thead th.tickerName {
  text-align: left;
}

.sec-ind-container .sec-ind-table thead th.perf1D {
  text-align: center;
}
.sec-ind-container .sec-ind-table thead th.perf1M {
  text-align: center;
}

.sec-ind-container .sec-ind-table thead th.perf3M {
  text-align: center;
}

.sec-ind-container .sec-ind-table thead th.perf6M {
  text-align: center;
}

.sec-ind-container .sec-ind-table thead th.perf1Y {
  text-align: center;
}

.sec-ind-container .sec-ind-table thead th:last-child {
  width: 30px;
  max-width: 30px;
  border: none;
}

.sec-ind-container .sec-ind-table thead th.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

/*.sec-ind-container .sec-ind-table thead th.sortable:hover {
    background-color: #f0f0f0;
}*/

.sec-ind-container .sec-ind-table thead th.sortable svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  transition: transform 0.2s ease;
}

.sec-ind-container .sec-ind-table tbody td.highlighted {
  font-weight: bold !important;
}
.sec-ind-container .sec-ind-table tbody tr {
  vertical-align: middle;
}
.sec-ind-container .sec-ind-table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.sec-ind-container .sec-ind-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  height: 40px;
  padding-top: 0;
  padding-bottom: 0;
  box-sizing: border-box;
}
.sec-ind-container .sec-ind-table tbody td:first-child {
  width: 30px;
  max-width: 30px;
}

.sec-ind-container .sec-ind-table tbody td.no {
  text-align: justify;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table tbody td.ctry {
  text-align: left;
  width: 28px;
  max-width: 28px;
}

.sec-ind-container .sec-ind-table tbody td.ctry svg {
  width: 20px;
  height: 20px;
}

.sec-ind-container .sec-ind-table tbody td.ticker {
  text-align: left;
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table tbody td.name {
  text-align: left;
  font-weight: 400;
  font-size: 16px; /* company name 14px */
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-ticker);
  cursor: pointer;
}
.sec-ind-tbl-cel-text {
  white-space: pre-wrap !important;
}
.sec-ind-container .sec-ind-table tbody td.tickerName {
  text-align: left;
  padding-top: 8px;
}

.sec-ind-container .sec-ind-table tbody td.tickerName .ticker {
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.sec-ind-container .sec-ind-table tbody td.tickerName .name {
  text-align: left;
  font-weight: 400;
  font-size: 14px; /* enlarge company name */
  letter-spacing: 0;
  color: var(--text-primary);
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table tbody td.last {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  min-width: 77px;
  padding-right: 8px;
}

.sec-ind-container .sec-ind-table tbody td.noborder {
  border: none !important;
  color: var(--text-secondary);
}

.sec-ind-container .sec-ind-table tbody td.nochange {
  color: var(--text-unchg-color);
}

.sec-ind-container .sec-ind-table tbody td.positive {
  color: var(--text-up-color);
}

.sec-ind-container .sec-ind-table tbody td.negative {
  color: var(--text-down-color);
}

.sec-ind-container .sec-ind-table tbody td.perf1D {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--surface-primary);
  min-width: 80px;
  padding-right: 8px;
  max-height: 56px;
}
.sec-ind-container .sec-ind-table tbody td.perf1M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--surface-primary);
  min-width: 80px;
  padding-right: 8px;
  max-height: 56px;
}

.sec-ind-container .sec-ind-table tbody td.perf3M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--surface-primary);
  min-width: 80px;
  padding-right: 8px;
  max-height: 56px;
}

.sec-ind-container .sec-ind-table tbody td.perf6M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--surface-primary);
  min-width: 80px;
  padding-right: 8px;
  max-height: 56px;
}

.sec-ind-container .sec-ind-table tbody td.perf1Y {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--surface-primary);
  min-width: 80px;
  padding-right: 8px;
  max-height: 56px;
}

.sec-ind-container .sec-ind-table tbody td.lastcolumn {
  width: 0;
  border: none;
}

.sec-ind-container .sec-ind-table tfoot td {
  height: 52px;
  padding-left: 24px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}

.sec-ind-container {
  .rec-strong-buy {
    background-color: var(--heatmap-up-5);
    color: var(--text-invert);
  }

  .rec-buy {
    background-color: var(--heatmap-up-4);
    color: var(--text-invert);
  }

  .rec-hold {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
  }

  .rec-reduce {
    background-color: var(--heatmap-down-4);
    color: var(--text-invert);
  }

  .rec-sell {
    background-color: var(--heatmap-down-6);
    color: var(--text-invert);
  }

  .sec-ind-whitespace {
    height: 24px;
  }

  .alignRight {
    text-align: right;
  }

  .alignCenter {
    text-align: center;
  }

  .sec-ind-tbl-cel-flex-container {
    display: flex;
    align-items: center;
    max-width: 90%;
  }

  .sec-ind-tbl-cel-text {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 56px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
@container (min-width: 360px) {
  .sec-ind-container .sec-ind-table thead th:first-child {
    width: 22px;
    max-width: 22px;
  }
  .sec-ind-container .sec-ind-table thead th:last-child {
    width: 22px;
    max-width: 22px;
  }

  .sec-ind-container .sec-ind-table tbody td:first-child {
    width: 22px;
    max-width: 22px;
  }
  .sec-ind-container .sec-ind-table tbody td:last-child {
    width: 22px;
    max-width: 22px;
  }
}

@container (min-width: 768px) {
  .sec-ind-container .sec-ind-table thead th:first-child {
    width: 30px;
    max-width: 30px;
  }
  .sec-ind-container .sec-ind-table thead th:last-child {
    width: 30px;
    max-width: 30px;
  }

  .sec-ind-container .sec-ind-table thead th.perf1D,
  .sec-ind-container .sec-ind-table thead th.perf1M,
  .sec-ind-container .sec-ind-table thead th.perf3M,
  .sec-ind-container .sec-ind-table thead th.perf6M,
  .sec-ind-container .sec-ind-table thead th.perf1Y {
    padding-right: 8px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf1D {
    width: 8%;
    min-width: 80px;
  }
  .sec-ind-container .sec-ind-table tbody td.perf1M {
    width: 8%;
    min-width: 80px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf3M {
    width: 8%;
    min-width: 80px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf6M {
    width: 8%;
    min-width: 80px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf1Y {
    width: 8%;
    min-width: 80px;
  }
  .sec-ind-container .sec-ind-table thead th:last-child,
  .sec-ind-container .sec-ind-table tbody td:last-child,
  .sec-ind-container .sec-ind-table tbody td.lastcolumn {
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .sec-ind-container .sec-ind-table thead th:first-child,
  .sec-ind-container .sec-ind-table tbody td:first-child {
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .sec-ind-container .sec-ind-table thead th.ctry,
  .sec-ind-container .sec-ind-table tbody td.ctry {
    padding-left: 0px;
    padding-right: 8px;
  }
}

@container (max-width: 767px) {
  .sec-ind-container .sec-ind-table tbody td.tickerName {
    padding-top: 0;
  }

  .sec-ind-container .sec-ind-table thead th.perf1D {
    text-align: right;
  }
  .sec-ind-container .sec-ind-table thead th.perf1M {
    text-align: right;
  }

  .sec-ind-container .sec-ind-table thead th.perf3M {
    text-align: right;
  }

  .sec-ind-container .sec-ind-table thead th.perf6M {
    text-align: right;
  }

  .sec-ind-container .sec-ind-table thead th.perf1Y {
    text-align: right;
  }

  .sec-ind-container .sec-ind-table tbody td.perf1D {
    padding-right: 0px;
  }
  .sec-ind-container .sec-ind-table tbody td.perf1M {
    padding-right: 0px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf3M {
    padding-right: 0px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf6M {
    padding-right: 0px;
  }

  .sec-ind-container .sec-ind-table tbody td.perf1Y {
    padding-right: 0px;
  }
  .sec-ind-container .sec-ind-table thead th:last-child,
  .sec-ind-container .sec-ind-table tbody td:last-child,
  .sec-ind-container .sec-ind-table tbody td.lastcolumn {
    width: 16px;
    min-width: 16px;
    max-width: 16px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .sec-ind-container .sec-ind-table thead th:first-child,
  .sec-ind-container .sec-ind-table tbody td:first-child {
    width: 16px;
    min-width: 16px;
    max-width: 16px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .sec-ind-container .sec-ind-table thead th.ctry,
  .sec-ind-container .sec-ind-table tbody td.ctry {
    padding-left: 0px;
  }
}

.sort-icon-asc path,
.sort-icon-desc path {
  fill: var(--color-brand);
}

.sec-ind-container .sec-ind-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 32px;
  padding: 0 8px;
  border-bottom: 1px solid var(--border-line);
  box-sizing: border-box;
}

.sec-ind-container .sec-ind-list-header .sec-ind-list-name,
.sec-ind-container .sec-ind-list-header .sec-ind-list-perf {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.sec-ind-container .sec-ind-list-header .sec-ind-list-perf {
  justify-content: flex-end;
}

.sec-ind-container .sec-ind-list-name.sortable,
.sec-ind-container .sec-ind-list-perf.sortable {
  cursor: pointer;
  user-select: none;
}

.sec-ind-container .sec-ind-list-name.sortable svg,
.sec-ind-container .sec-ind-list-perf.sortable svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  transition: transform 0.2s ease;
}

.sec-ind-container .sec-ind-list-body .sec-ind-list-row:nth-child(2n) {
  background-color: var(--row-dark);
}

.sec-ind-container .sec-ind-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 40px;
  padding: 8px;
  box-sizing: border-box;
}

.sec-ind-container .sec-ind-list-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
}

.sec-ind-container .sec-ind-list-ctry {
  flex: none;
  display: inline-flex;
}

.sec-ind-container .sec-ind-list-ctry svg {
  width: 20px;
  height: 20px;
}

.sec-ind-container .sec-ind-list-name {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-ticker);
  cursor: pointer;
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.sec-ind-container .sec-ind-list-name .sec-ind-tbl-cel-flex-container {
  max-width: 100%;
  width: 100%;
}

.sec-ind-container .sec-ind-list-name.highlighted {
  font-weight: bold !important;
}

.sec-ind-container .sec-ind-list-perf {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-secondary);
  white-space: nowrap;
  flex: none;
}

.sec-ind-container .sec-ind-list-perf.nochange {
  color: var(--text-unchg-color);
}

.sec-ind-container .sec-ind-list-perf.positive {
  color: var(--text-up-color);
}

.sec-ind-container .sec-ind-list-perf.negative {
  color: var(--text-down-color);
}

.sec-ind-container .sec-ind-list-no-data {
  padding: 16px 8px;
  text-align: center;
  color: var(--text-secondary);
}

.sec-ind-container .sec-ind-list-footer {
  padding: 16px 8px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/SectorIndicesWidget/SectorIndicesWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;EAEE;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAE,sBAAsB;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;EAC5B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;EACvB;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;;;IAKE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;EACA;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;EACA;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":[".sec-ind-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  min-width: 328px;\n}\n\n.sec-ind-container .sec-ind-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.sec-ind-container .sec-ind-table thead th {\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n  box-sizing: border-box;\n  padding-top: 0;\n  padding-bottom: 0;\n  text-align: right;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: top;\n  white-space: nowrap;\n}\n.sec-ind-container .sec-ind-table thead th:first-child {\n  border: none;\n}\n\n.sec-ind-container .sec-ind-table thead th.no {\n  text-align: center;\n  width: 8px;\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table thead th.ctry {\n  width: 28px;\n  min-width: 28px;\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table thead th.ticker {\n  text-align: left;\n  width: 62px;\n  min-width: 62px;\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table thead th.name {\n  text-align: left;\n  min-width: 150px;\n}\n\n.sec-ind-container .sec-ind-table thead th.tickerName {\n  text-align: left;\n}\n\n.sec-ind-container .sec-ind-table thead th.perf1D {\n  text-align: center;\n}\n.sec-ind-container .sec-ind-table thead th.perf1M {\n  text-align: center;\n}\n\n.sec-ind-container .sec-ind-table thead th.perf3M {\n  text-align: center;\n}\n\n.sec-ind-container .sec-ind-table thead th.perf6M {\n  text-align: center;\n}\n\n.sec-ind-container .sec-ind-table thead th.perf1Y {\n  text-align: center;\n}\n\n.sec-ind-container .sec-ind-table thead th:last-child {\n  width: 30px;\n  max-width: 30px;\n  border: none;\n}\n\n.sec-ind-container .sec-ind-table thead th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n/*.sec-ind-container .sec-ind-table thead th.sortable:hover {\n    background-color: #f0f0f0;\n}*/\n\n.sec-ind-container .sec-ind-table thead th.sortable svg {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n  transition: transform 0.2s ease;\n}\n\n.sec-ind-container .sec-ind-table tbody td.highlighted {\n  font-weight: bold !important;\n}\n.sec-ind-container .sec-ind-table tbody tr {\n  vertical-align: middle;\n}\n.sec-ind-container .sec-ind-table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.sec-ind-container .sec-ind-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  height: 40px;\n  padding-top: 0;\n  padding-bottom: 0;\n  box-sizing: border-box;\n}\n.sec-ind-container .sec-ind-table tbody td:first-child {\n  width: 30px;\n  max-width: 30px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.no {\n  text-align: justify;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.ctry {\n  text-align: left;\n  width: 28px;\n  max-width: 28px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.ctry svg {\n  width: 20px;\n  height: 20px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.ticker {\n  text-align: left;\n  text-decoration: underline;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.name {\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px; /* company name 14px */\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-ticker);\n  cursor: pointer;\n}\n.sec-ind-tbl-cel-text {\n  white-space: pre-wrap !important;\n}\n.sec-ind-container .sec-ind-table tbody td.tickerName {\n  text-align: left;\n  padding-top: 8px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.tickerName .ticker {\n  text-decoration: underline;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.sec-ind-container .sec-ind-table tbody td.tickerName .name {\n  text-align: left;\n  font-weight: 400;\n  font-size: 14px; /* enlarge company name */\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.last {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  min-width: 77px;\n  padding-right: 8px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.noborder {\n  border: none !important;\n  color: var(--text-secondary);\n}\n\n.sec-ind-container .sec-ind-table tbody td.nochange {\n  color: var(--text-unchg-color);\n}\n\n.sec-ind-container .sec-ind-table tbody td.positive {\n  color: var(--text-up-color);\n}\n\n.sec-ind-container .sec-ind-table tbody td.negative {\n  color: var(--text-down-color);\n}\n\n.sec-ind-container .sec-ind-table tbody td.perf1D {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid var(--surface-primary);\n  min-width: 80px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n.sec-ind-container .sec-ind-table tbody td.perf1M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid var(--surface-primary);\n  min-width: 80px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.perf3M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid var(--surface-primary);\n  min-width: 80px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.perf6M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid var(--surface-primary);\n  min-width: 80px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.perf1Y {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid var(--surface-primary);\n  min-width: 80px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.sec-ind-container .sec-ind-table tbody td.lastcolumn {\n  width: 0;\n  border: none;\n}\n\n.sec-ind-container .sec-ind-table tfoot td {\n  height: 52px;\n  padding-left: 24px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.sec-ind-container {\n  .rec-strong-buy {\n    background-color: var(--heatmap-up-5);\n    color: var(--text-invert);\n  }\n\n  .rec-buy {\n    background-color: var(--heatmap-up-4);\n    color: var(--text-invert);\n  }\n\n  .rec-hold {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n  }\n\n  .rec-reduce {\n    background-color: var(--heatmap-down-4);\n    color: var(--text-invert);\n  }\n\n  .rec-sell {\n    background-color: var(--heatmap-down-6);\n    color: var(--text-invert);\n  }\n\n  .sec-ind-whitespace {\n    height: 24px;\n  }\n\n  .alignRight {\n    text-align: right;\n  }\n\n  .alignCenter {\n    text-align: center;\n  }\n\n  .sec-ind-tbl-cel-flex-container {\n    display: flex;\n    align-items: center;\n    max-width: 90%;\n  }\n\n  .sec-ind-tbl-cel-text {\n    flex: 1 1 0;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-height: 56px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n  }\n}\n@container (min-width: 360px) {\n  .sec-ind-container .sec-ind-table thead th:first-child {\n    width: 22px;\n    max-width: 22px;\n  }\n  .sec-ind-container .sec-ind-table thead th:last-child {\n    width: 22px;\n    max-width: 22px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td:first-child {\n    width: 22px;\n    max-width: 22px;\n  }\n  .sec-ind-container .sec-ind-table tbody td:last-child {\n    width: 22px;\n    max-width: 22px;\n  }\n}\n\n@container (min-width: 768px) {\n  .sec-ind-container .sec-ind-table thead th:first-child {\n    width: 30px;\n    max-width: 30px;\n  }\n  .sec-ind-container .sec-ind-table thead th:last-child {\n    width: 30px;\n    max-width: 30px;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.perf1D,\n  .sec-ind-container .sec-ind-table thead th.perf1M,\n  .sec-ind-container .sec-ind-table thead th.perf3M,\n  .sec-ind-container .sec-ind-table thead th.perf6M,\n  .sec-ind-container .sec-ind-table thead th.perf1Y {\n    padding-right: 8px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf1D {\n    width: 8%;\n    min-width: 80px;\n  }\n  .sec-ind-container .sec-ind-table tbody td.perf1M {\n    width: 8%;\n    min-width: 80px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf3M {\n    width: 8%;\n    min-width: 80px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf6M {\n    width: 8%;\n    min-width: 80px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf1Y {\n    width: 8%;\n    min-width: 80px;\n  }\n  .sec-ind-container .sec-ind-table thead th:last-child,\n  .sec-ind-container .sec-ind-table tbody td:last-child,\n  .sec-ind-container .sec-ind-table tbody td.lastcolumn {\n    width: 32px;\n    min-width: 32px;\n    max-width: 32px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .sec-ind-container .sec-ind-table thead th:first-child,\n  .sec-ind-container .sec-ind-table tbody td:first-child {\n    width: 32px;\n    min-width: 32px;\n    max-width: 32px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.ctry,\n  .sec-ind-container .sec-ind-table tbody td.ctry {\n    padding-left: 0px;\n    padding-right: 8px;\n  }\n}\n\n@container (max-width: 767px) {\n  .sec-ind-container .sec-ind-table tbody td.tickerName {\n    padding-top: 0;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.perf1D {\n    text-align: right;\n  }\n  .sec-ind-container .sec-ind-table thead th.perf1M {\n    text-align: right;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.perf3M {\n    text-align: right;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.perf6M {\n    text-align: right;\n  }\n\n  .sec-ind-container .sec-ind-table thead th.perf1Y {\n    text-align: right;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf1D {\n    padding-right: 0px;\n  }\n  .sec-ind-container .sec-ind-table tbody td.perf1M {\n    padding-right: 0px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf3M {\n    padding-right: 0px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf6M {\n    padding-right: 0px;\n  }\n\n  .sec-ind-container .sec-ind-table tbody td.perf1Y {\n    padding-right: 0px;\n  }\n  .sec-ind-container .sec-ind-table thead th:last-child,\n  .sec-ind-container .sec-ind-table tbody td:last-child,\n  .sec-ind-container .sec-ind-table tbody td.lastcolumn {\n    width: 16px;\n    min-width: 16px;\n    max-width: 16px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .sec-ind-container .sec-ind-table thead th:first-child,\n  .sec-ind-container .sec-ind-table tbody td:first-child {\n    width: 16px;\n    min-width: 16px;\n    max-width: 16px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .sec-ind-container .sec-ind-table thead th.ctry,\n  .sec-ind-container .sec-ind-table tbody td.ctry {\n    padding-left: 0px;\n  }\n}\n\n.sort-icon-asc path,\n.sort-icon-desc path {\n  fill: var(--color-brand);\n}\n\n.sec-ind-container .sec-ind-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 32px;\n  padding: 0 8px;\n  border-bottom: 1px solid var(--border-line);\n  box-sizing: border-box;\n}\n\n.sec-ind-container .sec-ind-list-header .sec-ind-list-name,\n.sec-ind-container .sec-ind-list-header .sec-ind-list-perf {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.sec-ind-container .sec-ind-list-header .sec-ind-list-perf {\n  justify-content: flex-end;\n}\n\n.sec-ind-container .sec-ind-list-name.sortable,\n.sec-ind-container .sec-ind-list-perf.sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.sec-ind-container .sec-ind-list-name.sortable svg,\n.sec-ind-container .sec-ind-list-perf.sortable svg {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n  transition: transform 0.2s ease;\n}\n\n.sec-ind-container .sec-ind-list-body .sec-ind-list-row:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.sec-ind-container .sec-ind-list-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 40px;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.sec-ind-container .sec-ind-list-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.sec-ind-container .sec-ind-list-ctry {\n  flex: none;\n  display: inline-flex;\n}\n\n.sec-ind-container .sec-ind-list-ctry svg {\n  width: 20px;\n  height: 20px;\n}\n\n.sec-ind-container .sec-ind-list-name {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-ticker);\n  cursor: pointer;\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.sec-ind-container .sec-ind-list-name .sec-ind-tbl-cel-flex-container {\n  max-width: 100%;\n  width: 100%;\n}\n\n.sec-ind-container .sec-ind-list-name.highlighted {\n  font-weight: bold !important;\n}\n\n.sec-ind-container .sec-ind-list-perf {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  flex: none;\n}\n\n.sec-ind-container .sec-ind-list-perf.nochange {\n  color: var(--text-unchg-color);\n}\n\n.sec-ind-container .sec-ind-list-perf.positive {\n  color: var(--text-up-color);\n}\n\n.sec-ind-container .sec-ind-list-perf.negative {\n  color: var(--text-down-color);\n}\n\n.sec-ind-container .sec-ind-list-no-data {\n  padding: 16px 8px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.sec-ind-container .sec-ind-list-footer {\n  padding: 16px 8px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
